var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var A = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #0076ff;\n  :hover,\n  :active,\n  :visited {\n    color: #0076ff;\n  }\n  font-family: inherit;\n  text-decoration: none;\n"], ["\n  color: #0076ff;\n  :hover,\n  :active,\n  :visited {\n    color: #0076ff;\n  }\n  font-family: inherit;\n  text-decoration: none;\n"])));
var templateObject_1;
//# sourceMappingURL=Links.js.map